var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSolidChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.759 6.38h8.482a.76.76 0 0 0 .537-1.297L5.537.843a.76.76 0 0 0-1.074 0l-4.24 4.24A.76.76 0 0 0 .758 6.38"
})));
export { SvgSolidChevronUp as ReactComponent };
export default __webpack_public_path__ + "7880279ae6ff68080f615d645032d29f.svg";